/* eslint-disable warp-drive/no-legacy-request-patterns */
// Extends From
import Route from '@ember/routing/route';

// Ember Imports
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';

// External Imports
import { hash } from '@linc-technologies/linced-common/utils/promise';

// Internal Imports
import PersonType from '@linc-technologies/linced-common/enums/person-type';

export default class IndexRoute extends Route {
  queryParams = {
    authorIds: {
      refreshModel: true,
    },
    groupIds: {
      refreshModel: true,
    },
  };

  // Services
  @service
  dates;

  @service
  session;

  @service
  store;

  model(params) {
    let authorIds = '';
    if (!isEmpty(params.authorIds)) {
      authorIds = JSON.stringify(params.authorIds);
    }
    let groupIds = '';
    if (!isEmpty(params.groupIds)) {
      groupIds = JSON.stringify(params.groupIds);
    }

    return hash({
      events: this.store.query('events/event', {
        authorIds,
        groupIds,
        includeHistoric: true,
        includeInternal: true,
        schoolId: this.session.activeSchool,
      }),
      staff: this.store.query('person', {
        type: PersonType.STAFF,
      }),
      groups: this.store.query('group', {
        year: this.dates.currentAcademicYear,
      }),
      permissions: this.store.findAll('events/permission'),
      risks: this.store.findAll('events/risk'),
      mitigations: this.store.findAll('events/mitigation'),
      locations: this.store.query('schools/location', {
        schoolId: this.session.activeSchool,
      }),
      peopleSchemaFields: this.store.findAll('people-schema/field'),
      update: () => this.refresh(),
    });
  }
}
